import type { ApexOptions } from 'apexcharts'
import type { MRRData } from '../../../features/revenue/domain/models/mrr'
import { DataType } from '../../../features/revenue/domain/models/mrr'
import {
  buildStackedBarWithLineOptions,
  MRRChartColors,
  monthYearFormatter,
  createYAxisFormatter,
  createTooltipValueFormatter,
  type ChartSeriesItem
} from '../charts'

export const getMRRChartOptions = (
  data: MRRData[],
  dataType: DataType,
  formatCategory: (dateStr: string) => string = monthYearFormatter
): ApexOptions => {
  const isEconomics = dataType === DataType.Economics

  const categories = data.map((d) => formatCategory(d.date))

  const barSeries: ChartSeriesItem[] = [
    {
      name: 'Churn',
      data: data.map((d) => d.churn),
      color: MRRChartColors.churn
    },
    {
      name: 'Existing',
      data: data.map((d) => d.existing),
      color: MRRChartColors.existing
    },
    {
      name: 'New',
      data: data.map((d) => d.new),
      color: MRRChartColors.new
    }
  ]

  const lineSeries: ChartSeriesItem = {
    name: 'Total Trend',
    data: data.map((d) => d.total),
    color: MRRChartColors.totalTrend
  }

  return buildStackedBarWithLineOptions({
    series: barSeries,
    lineSeries,
    categories,
    height: 400,
    yAxisFormatter: createYAxisFormatter(isEconomics),
    tooltipValueFormatter: createTooltipValueFormatter(isEconomics),
    xAxisLabelFormatter: (v) => v
  })
}
